import { t } from 'i18next'
import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'
import tableTemplate from './tableTemplate'

/**
 * Builds the "Honorary Pallbearers" subheading + honorary table HTML block.
 *
 * Shared by the insert-menu path (handlePallbearersArray) and the dynamic-text
 * refresh path (updateCaseDetailTables) so the markup — including the
 * `data-honorary-pallbearers-heading` marker the refresh relies on — stays in
 * sync. Returns an empty string when there are no honorary names.
 */
export const buildHonoraryPallbearersBlock = ({
  honoraryNames,
  selectedTheme,
  editor,
}: {
  honoraryNames: string[] | null | undefined
  selectedTheme: unknown
  editor: unknown
}): string => {
  if (!honoraryNames || honoraryNames.length === 0) return ''

  const themeStyles = getThemeStylesForTemplate({
    selectedTheme: selectedTheme as Parameters<
      typeof getThemeStylesForTemplate
    >[0]['selectedTheme'],
    editor: editor as Parameters<typeof getThemeStylesForTemplate>[0]['editor'],
  })

  const heading = `<p class="mceNonEditable" data-honorary-pallbearers-heading="true" style="text-align: center; ${themeStyles}"><strong>${t('caseFormSectionsLabels.Honorary Pallbearers Heading')}</strong></p>`

  const table = tableTemplate({
    path: 'honorary_pallbearers',
    items: honoraryNames,
    selectedTheme,
    editor,
  })

  return `${heading}${table}`
}

export default buildHonoraryPallbearersBlock
